const selectColor: {
  color: string;
  buttonColor: string;
}[] = [
  {
    color: "#1D5872",
    buttonColor: "#277684",
  },
  {
    color: "#B30000",
    buttonColor: "#002DB3",
  },
  {
    color: "#EB6924",
    buttonColor: "#000000",
  },
  {
    color: "#7D66D9",
    buttonColor: "#4953B4",
  },
  {
    color: "#00337C",
    buttonColor: "#4B155B",
  },
  {
    color: "#B2114C",
    buttonColor: "#5C4252",
  },
];

export default selectColor;
